import React from "react";
import "./s.css";
import Form from "../form";
import Location from "../location";

const Contacto = () => {
  return (
    <div className="contacto">
      <Form />
      <Location />
    </div>
  );
};

export default Contacto;